import { Box, Stack, Typography } from "@mui/material";
import { PieChart } from '@mui/x-charts/PieChart';

const ActionPieChart = ({Data}) => {
    const pieData =
    Data &&
    Object.entries(Data)
    .filter(([_, val]) => val.loanAmtApprv > 0)
    .map(([key, val]) => ({
      id: key,
      value: val.loanAmtApprv,
      label: `${key} - ₹${val.loanAmtApprv.toLocaleString()}`,
    }));

    
    return (
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
        <Box  sx={{
    width: '100%',
  maxWidth: {
    xs: '250px',
    md: 'none',
  },
    mx: 'auto',
  }}>
          <PieChart
            series={[
              {
                innerRadius: 0,
                outerRadius: 100,
                data: pieData,
              },
            ]}
            width={250}
            height={200}
            // onItemClick={(e, item) => setSelectedData(item)}
          />
        </Box>

        {/* <Box sx={{ width: { xs: '100%', md: '40%' } }}>
          <Typography variant="subtitle1" className="mb-2">
            Clicked Item Details:
          </Typography>
          <pre className="bg-gray-100 p-3 rounded text-sm">
            {selectedData
              ? JSON.stringify(selectedData, null, 2)
              : '// Click a pie slice to see details'}
          </pre>
        </Box> */}
      </Stack>
    )
}

export default ActionPieChart